import { useResetPass } from "@/features/user/hooks/use-reset-pass";
import { MailAddressForm } from "@/shared/components/text-box/mail-address-form";
import { FixedWebWidthContentWrapper } from "@/shared/components/page/fixed-web-width-content-wrapper";
import React from "react";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { useNavigate } from "react-router-dom";
import { EndpointPathNames } from "@/shared/config/endpoint-path";
import { LoginHeader } from "@/shared/components/header/login-header";
import { Footer } from "@/shared/components/footer/footer";

export const ResetPassDone = () => {
  const storedEmail = localStorage.getItem("resetPassEmail") || "";
  const navigate = useNavigate();

  // メールアドレスフォームに付与するID
  const mailAddressFormId = "rePassMail";

  return (
    <>
      <LoginHeader content="パスワードの再設定" />
      <main>
        <section id="rePass">
          <nav className="step">
            <ol>
              <li className="active">再設定メールを送信</li>
              <li>新パスワードの設定</li>
              <li>再設定完了</li>
            </ol>
          </nav>
          <p>パスワード再設定メールを送信しました</p>
          <ul className="form">
            <li>
              <MailAddressForm
              id={mailAddressFormId}
              initialValue={storedEmail}
              isReadOnly={true}
              title="メールアドレス"
            />
            </li>
          </ul>
          <div className="notice">
            <p>メールサーバー上で自動的に、&quot;迷惑メール&quot;などの通常使用しているフォルダ以外に送信される場合がありますのでご注意ください。</p>
            <p>URL付きメールが受信拒否になっている場合や、ドメイン指定などでの受信設定の影響で届かない場合があります。「@mail.sorimachi.co.jp」のドメインを受信できるようご自身で設定ください。</p>
          </div>
          <nav className="btns">
            <BaseRoundButton
              className="btn-base"
              buttonText="やり直す"
              onClick={() => 
                navigate(EndpointPathNames.RESET_PASS)}
              isActive={true}
            />
          </nav>
        </section>
      </main>
      <Footer />
    </>
  );
};
